export const GET_ALL_SCREENS_DATA_REQUEST = "GET_ALL_SCREENS_DATA_REQUEST";
export const GET_ALL_SCREENS_DATA_SUCCESS = "GET_ALL_SCREENS_DATA_SUCCESS";
export const GET_ALL_SCREENS_DATA_FAIL = "GET_ALL_SCREENS_DATA_FAIL";

export const GET_SCREEN_DATA_REQUEST = "GET_SCREEN_DATA_REQUEST";
export const GET_SCREEN_DATA_SUCCESS = "GET_SCREEN_DATA_SUCCESS";
export const GET_SCREEN_DATA_FAIL = "GET_SCREEN_DATA_FAIL";

export const GET_SCREEN_CAMPAIGNS_DATA_REQUEST = "GET_SCREEN_CAMPAIGNS_DATA_REQUEST";
export const GET_SCREEN_CAMPAIGNS_DATA_SUCCESS = "GET_SCREEN_CAMPAIGNS_DATA_SUCCESS";
export const GET_SCREEN_CAMPAIGNS_DATA_FAIL = "GET_SCREEN_CAMPAIGNS_DATA_FAIL";

export const SET_CAMPAIGNS_LOOP_FOR_SCREEN_REQUEST = "SET_CAMPAIGNS_LOOP_FOR_SCREEN_REQUEST";
export const SET_CAMPAIGNS_LOOP_FOR_SCREEN_SUCCESS = "SET_CAMPAIGNS_LOOP_FOR_SCREEN_SUCCESS";
export const SET_CAMPAIGNS_LOOP_FOR_SCREEN_FAIL = "SET_CAMPAIGNS_LOOP_FOR_SCREEN_FAIL";
export const SET_CAMPAIGNS_LOOP_FOR_SCREEN_RESET = "SET_CAMPAIGNS_LOOP_FOR_SCREEN_RESET";

export const EDIT_CAMPAIGN_CREATIVE_END_DATE_REQUEST = "EDIT_CAMPAIGN_CREATIVE_END_DATE_REQUEST";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_SUCCESS = "EDIT_CAMPAIGN_CREATIVE_END_DATE_SUCCESS";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_FAIL = "EDIT_CAMPAIGN_CREATIVE_END_DATE_FAIL";
export const EDIT_CAMPAIGN_CREATIVE_END_DATE_RESET = "EDIT_CAMPAIGN_CREATIVE_END_DATE_RESET";

export const EDIT_DEFAULT_CREATIVE_REQUEST = "EDIT_DEFAULT_CREATIVE_REQUEST";
export const EDIT_DEFAULT_CREATIVE_SUCCESS = "EDIT_DEFAULT_CREATIVE_SUCCESS";
export const EDIT_DEFAULT_CREATIVE_FAIL = "EDIT_DEFAULT_CREATIVE_FAIL";
export const EDIT_DEFAULT_CREATIVE_RESET = "EDIT_DEFAULT_CREATIVE_RESET";

export const SCREEN_CAMPAIGN_MONITORING_REQUEST = "SCREEN_CAMPAIGN_MONITORING_REQUEST";
export const SCREEN_CAMPAIGN_MONITORING_SUCCESS = "SCREEN_CAMPAIGN_MONITORING_SUCCESS";
export const SCREEN_CAMPAIGN_MONITORING_FAIL = "SCREEN_CAMPAIGN_MONITORING_FAIL";
export const SCREEN_CAMPAIGN_MONITORING_RESET = "SCREEN_CAMPAIGN_MONITORING_RESET";

export const GET_SCREEN_CAMPAIGN_MONITORING_REQUEST =
  "GET_SCREEN_CAMPAIGN_MONITORING_REQUEST";
export const GET_SCREEN_CAMPAIGN_MONITORING_SUCCESS =
  "GET_SCREEN_CAMPAIGN_MONITORING_SUCCESS";
export const GET_SCREEN_CAMPAIGN_MONITORING_FAIL =
  "GET_SCREEN_CAMPAIGN_MONITORING_FAIL";
export const GET_SCREEN_CAMPAIGN_MONITORING_RESET =
  "GET_SCREEN_CAMPAIGN_MONITORING_RESET";

export const SCREEN_CODE_CHANGE_REQUEST = "SCREEN_CODE_CHANGE_REQUEST";
export const SCREEN_CODE_CHANGE_SUCCESS = "SCREEN_CODE_CHANGE_SUCCESS";
export const SCREEN_CODE_CHANGE_FAIL = "SCREEN_CODE_CHANGE_FAIL";
export const SCREEN_CODE_CHANGE_RESET = "SCREEN_CODE_CHANGE_RESET";

export const SCREEN_REFRESH_REQUEST = "SCREEN_REFRESH_REQUEST";
export const SCREEN_REFRESH_SUCCESS = "SCREEN_REFRESH_SUCCESS";
export const SCREEN_REFRESH_FAIL = "SCREEN_REFRESH_FAIL";

export const UPDATE_SCREENS_DATA_IN_REDIS_REQUEST = "UPDATE_SCREENS_DATA_IN_REDIS_REQUEST";
export const UPDATE_SCREENS_DATA_IN_REDIS_SUCCESS = "UPDATE_SCREENS_DATA_IN_REDIS_SUCCESS";
export const UPDATE_SCREENS_DATA_IN_REDIS_FAIL = "UPDATE_SCREENS_DATA_IN_REDIS_FAIL";

export const PLAY_HOLD_CAMPAIGNS_REQUEST = "PLAY_HOLD_CAMPAIGNS_REQUEST";
export const PLAY_HOLD_CAMPAIGNS_SUCCESS = "PLAY_HOLD_CAMPAIGNS_SUCCESS";
export const PLAY_HOLD_CAMPAIGNS_FAIL = "PLAY_HOLD_CAMPAIGNS_FAIL";
export const PLAY_HOLD_CAMPAIGNS_RESET = "PLAY_HOLD_CAMPAIGNS_RESET";

export const GET_SCREEN_LOGS_REQUEST = "GET_SCREEN_LOGS_REQUEST";
export const GET_SCREEN_LOGS_SUCCESS = "GET_SCREEN_LOGS_SUCCESS";
export const GET_SCREEN_LOGS_FAIL = "GET_SCREEN_LOGS_FAIL";

export const CHANGE_DEFAULT_SCREEN_MEDIA_REQUEST = "CHANGE_DEFAULT_SCREEN_MEDIA_REQUEST";
export const CHANGE_DEFAULT_SCREEN_MEDIA_SUCCESS = "CHANGE_DEFAULT_SCREEN_MEDIA_SUCCESS";
export const CHANGE_DEFAULT_SCREEN_MEDIA_FAIL = "CHANGE_DEFAULT_SCREEN_MEDIA_FAIL";
export const CHANGE_DEFAULT_SCREEN_MEDIA_RESET = "CHANGE_DEFAULT_SCREEN_MEDIA_RESET";

export const CHANGE_DEFAULT_INCLUDED_REQUEST = "CHANGE_DEFAULT_INCLUDED_REQUEST";
export const CHANGE_DEFAULT_INCLUDED_SUCCESS = "CHANGE_DEFAULT_INCLUDED_SUCCESS";
export const CHANGE_DEFAULT_INCLUDED_FAIL = "CHANGE_DEFAULT_INCLUDED_FAIL";
export const CHANGE_DEFAULT_INCLUDED_RESET = "CHANGE_DEFAULT_INCLUDED_RESET"

export const CHANGE_AUTO_LOOP_VALUE_REQUEST = "CHANGE_AUTO_LOOP_VALUE_REQUEST";
export const CHANGE_AUTO_LOOP_VALUE_SUCCESS = "CHANGE_AUTO_LOOP_VALUE_SUCCESS";
export const CHANGE_AUTO_LOOP_VALUE_FAIL = "CHANGE_AUTO_LOOP_VALUE_FAIL";
export const CHANGE_AUTO_LOOP_VALUE_RESET = "CHANGE_AUTO_LOOP_VALUE_RESET"
